import React, { Component } from "react";

export default class Front extends Component {
  render() {
    return <div>Front page</div>;
  }
}
